import { render, staticRenderFns } from "./scheme-prices.vue?vue&type=template&id=6efc2d44"
import script from "./scheme-prices.vue?vue&type=script&lang=js"
export * from "./scheme-prices.vue?vue&type=script&lang=js"
import style0 from "./scheme-prices.vue?vue&type=style&index=0&id=6efc2d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports